import { CheckCircle, Info, WarningCircle, X } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { RequestIdBadge } from '@/components/ui/States';
import { dismissToast, toast, useToasts } from '@/lib/toast';

/** Toast iz dizajna: navy, dolje desno, ikona zelena kvačica. */
export function Toaster() {
  const { t } = useTranslation();
  const items = useToasts();
  return (
    <div
      aria-live="polite"
      className="no-print fixed right-6 bottom-6 z-[310] flex flex-col items-end gap-2"
    >
      {items.map((it) => (
        <div
          key={it.id}
          role="status"
          className="flex items-center gap-2.5 rounded-lg bg-navy py-3.5 pr-3 pl-[18px] text-sm font-medium text-white shadow-card"
        >
          {it.tone === 'error' ? (
            <WarningCircle size={18} weight="fill" className="text-[#FF8A90]" />
          ) : it.tone === 'info' ? (
            <Info size={18} weight="fill" className="text-[#9CC8FF]" />
          ) : (
            <CheckCircle size={18} weight="fill" className="text-[#5FD39A]" />
          )}
          <span className="flex flex-col gap-0.5">
            <span>{it.message}</span>
            {it.requestId ? (
              <RequestIdBadge
                requestId={it.requestId}
                tone="inverse"
                onCopied={() => toast(t('common:support.codeCopied'), 'info')}
              />
            ) : null}
          </span>
          <button
            type="button"
            onClick={() => dismissToast(it.id)}
            aria-label={t('panel:toasts.dismiss')}
            className="ml-1 grid h-7 w-7 flex-none place-items-center self-start rounded-sm text-white/75 hover:text-white"
          >
            <X size={14} aria-hidden />
          </button>
        </div>
      ))}
    </div>
  );
}
